import Flyers from '../views/flyers/List.vue';
import { checkauth } from '../Helper';

const FlyerCreate = () => import('../views/flyers/Create.vue');
const FlyerEdit = () => import('../views/flyers/Edit.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/flyers', name: 'flyers', component: Flyers, beforeEnter: guard },
	{ path: '/flyers/new', name: 'flyers-new', component: FlyerCreate, beforeEnter: guard },
	{ path: '/flyers/:id([0-9a-fA-F]{24})', name: 'flyers-edit', component: FlyerEdit, beforeEnter: guard },
];
